<template>
  <form>
    <br />
    <center>
      <h1 class="title">Question {{ startStep + activeStep }}</h1>
    </center>
    <br />
    <div class="columns">
      <div class="column is-6 is-offset-3">
        <b-progress size="is-small" type="is-primary" :value="progressValue" />
      </div>
    </div>
    <center>
      <h6 class="subtitle is-6"><strong v-html="activeQuestion"></strong></h6>
    </center>
    <br />
    <div v-if="activeStep === 0">
      <div class="columns">
        <div class="column is-9">
          <b-notification :closable="false">
            <div class="buttons" style="display: flex; justify-content: center">
              <b-button
                v-for="(diet, index) in Object.keys(predifinedDiets)"
                :key="index"
                :label="$t('compCarbonFormsFoodsForm.' + diet + '-btn')"
                @click="setDiet(diet)"
                :type="dietBtnType(diet)"
                class="ml-1 mr-1"
              />
            </div>
          </b-notification>
        </div>
        <div class="column" style="display: flex">
          <b-notification
            :class="{ nmeals: true }"
            :type="errorNumberOfMeals ? 'is-danger' : ''"
            :closable="false"
            style="
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">
                  {{ $t('compCarbonFormsFoodsForm.label-1') }}
                </p>
                <div class="title is-size-2">
                  <p>
                    {{ nLeftMeals }}
                  </p>
                </div>
              </div>
            </div>
          </b-notification>
        </div>
      </div>
      <div class="columns is-multiline is-centered">
        <div
          v-for="(meal, index) in MEALS"
          :key="index"
          class="column is-6"
          style="display: flex"
        >
          <b-notification
            :closable="false"
            :has-icon="true"
            :icon="getIcon(meal)"
            icon-pack="icomoon"
            icon-size="is-medium"
          >
            <div class="columns">
              <div class="column">
                <strong> {{ $t(meal) }} </strong>
                <br />
                <em>
                  {{ $t('compCarbonFormsFoodsForm.' + meal + '-desc') }}
                </em>
              </div>
              <div class="column is-3">
                <b-input
                  min="0"
                  :max="nAllowedMeals(meal)"
                  v-model="cmeals[meal]"
                  type="number"
                />
              </div>
            </div>
          </b-notification>
        </div>
      </div>
    </div>
    <br />
    <b-notification
      v-if="activeStep === 1"
      :closable="false"
      :type="errors.has('nCateringMeal') ? 'is-danger' : ''"
    >
      <b-field
        :type="{ 'is-danger': errors.has('nCateringMeal') }"
        :message="errors.first('nCateringMeal')"
      >
        <b-select
          name="nCateringMeal"
          expanded
          v-validate="'required'"
          :placeholder="$t('compCarbonFormsFoodsForm.placeholder-1') + ' *'"
          v-model="buffer.nCateringMeal"
          @input="$emit('input', buffer)"
        >
          <option
            v-for="(nmeals, index) in cateringValues"
            :key="index"
            :value="nmeals"
          >
            <span v-if="[0, 1].includes(nmeals)"
              >{{ nmeals }} {{ $t('compCarbonFormsFoodsForm.nmeal') }}</span
            >
            <span v-else
              >{{ nmeals }} {{ $t('compCarbonFormsFoodsForm.nmeals') }}</span
            >
          </option>
        </b-select>
      </b-field>
    </b-notification>
    <div class="columns">
      <div class="column">
        <b-button
          class="button is-fullwidth"
          :disabled="isSimulation"
          @click="previousStep"
          data-testid="previous-step"
          icon-left="angle-double-left"
        >
          {{ $t('previous') }}
        </b-button>
      </div>
      <div class="column">
        <b-button
          class="button is-fullwidth is-primary"
          @click="nextStep"
          data-testid="next-step-food"
          icon-right="angle-double-right"
        >
          {{ nextBtnLabel }}
        </b-button>
      </div>
    </div>
  </form>
</template>

<script>
import Food from '@/models/carbon/Food.js'
export default {
  name: 'Form',
  props: {
    value: {
      type: Object,
      default: function () {
        return {}
      }
    },
    year: {
      type: Number,
      default: new Date().getFullYear() - 1
    },
    isSurvey: {
      type: Boolean,
      default: false
    },
    isSimulation: {
      type: Boolean,
      default: false
    },
    totalStep: {
      type: Number,
      default: 2
    },
    startStep: {
      type: Number,
      default: 0
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      activeStep: 0,
      MEALS: Food.MEALS,
      buffer: Food.createFromObj(this.value),
      errorNumberOfMeals: false,
      cmeals: {}
    }
  },
  computed: {
    predifinedDiets: function () {
      return Food.getDiets(this.buffer.nMeals)
    },
    cateringValues: function () {
      return [...Array(this.buffer.nMeals + 1).keys()]
    },
    nLeftMeals: function () {
      return this.buffer.nMeals - this.totalMealsSelected
    },
    totalMealsSelected: function () {
      return this.buffer.meals
        .map((obj) => obj.amount)
        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
    },
    progressValue: function () {
      return ((this.activeStep + this.startStep) / this.totalStep) * 100
    },
    activeQuestion: function () {
      if (this.activeStep === 0) {
        if (this.isSimulation) {
          return this.$t('compCarbonFormsFoodsForm.question-simulation')
        } else {
          return (
            this.$t('compCarbonFormsFoodsForm.question-1-1') +
            ' ' +
            this.buffer.nMeals +
            ' ' +
            this.$t('compCarbonFormsFoodsForm.question-1-2')
          )
        }
      } else {
        return (
          this.$t('compCarbonFormsFoodsForm.question-2-1') +
          ' ' +
          this.buffer.nMeals +
          ' ' +
          this.$t('compCarbonFormsFoodsForm.question-2-2')
        )
      }
    },
    nextBtnLabel: function () {
      if (!this.isSimulation && this.isSurvey && this.progressValue === 100) {
        return this.$t('preview')
      }
      if (this.isSimulation && this.progressValue === 100) {
        return this.$t('add-simu')
      }
      if (!this.isSimulation && !this.isSurvey && this.progressValue === 100) {
        return this.$t('add')
      } else {
        return this.$t('next')
      }
    }
  },
  methods: {
    getIcon: function (meal) {
      return Food.ICONS(meal)
    },
    getInitialMeals () {
      let meals = {}
      for (let meal of this.MEALS) {
        meals[meal] = 0
      }
      return meals
    },
    nAllowedMeals: function (meal) {
      let nMeals = this.buffer.meals
        .filter((obj) => obj.type !== meal)
        .map((obj) => obj.amount)
        .reduce((a, b) => parseInt(a) + parseInt(b), 0)
      return this.buffer.nMeals - nMeals
    },
    isNumberOfMealsValid: function () {
      let valid = this.totalMealsSelected === this.buffer.nMeals
      this.errorNumberOfMeals = !valid
      return valid
    },
    dietBtnType (diet) {
      let type = 'is-primary'
      for (let meal of Object.keys(this.predifinedDiets[diet])) {
        let bmeal = this.buffer.meals.filter((obj) => obj.type === meal)
        if (bmeal.length === 1) {
          if (this.predifinedDiets[diet][meal] !== parseInt(bmeal[0].amount)) {
            type = ''
            break
          }
        } else {
          type = ''
          break
        }
      }
      return type
    },
    setDiet (diet) {
      for (let meal of Object.keys(this.predifinedDiets[diet])) {
        this.cmeals[meal] = this.predifinedDiets[diet][meal]
      }
      this.errorNumberOfMeals = false
    },
    mealIconPack () {},
    mealIcon () {},
    previousStep () {
      if (this.activeStep > 0) {
        this.activeStep -= 1
      } else {
        this.$emit('back')
      }
    },
    nextStep () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.activeStep === 0) {
            if (this.isNumberOfMealsValid()) {
              if (this.isSimulation) {
                this.$emit('submit')
              } else {
                this.activeStep += 1
              }
            }
          } else if (this.activeStep === 1) {
            this.$emit('submit')
          } else {
            this.activeStep += 1
          }
        }
      })
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = Food.createFromObj(this.value)
      },
      deep: true
    },
    cmeals: {
      handler () {
        this.buffer.meals = []
        for (let meal of Object.keys(this.cmeals)) {
          this.buffer.addMeal({
            type: meal,
            amount: this.cmeals[meal]
          })
        }
        if (this.errorNumberOfMeals) {
          this.isNumberOfMealsValid()
        }
        this.$emit('input', this.buffer)
      },
      deep: true
    }
  },
  mounted () {
    this.cmeals = this.getInitialMeals()
  }
}
</script>

<style>
.notification.is-danger.nmeals {
  background-color: hsl(348deg, 86%, 61%) !important;
  color: #ffffff !important;
}
</style>
